module.exports = __webpack_public_path__ + "static/media/instagram (2).76d0a190.svg";